export const getVideoDimensions = (file) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        const reader = new FileReader();

        reader.onload = (e) => {
            video.src = e.target.result;
        };

        video.onloadedmetadata = () => {
            resolve({ width: video.videoWidth, height: video.videoHeight });
        };

        video.onerror = (error) => {
            console.error('Error loading video', error);
            resolve(null); // Resolve with null if it's not a valid video
        };

        reader.readAsDataURL(file);
    });
};
